const STEPS = [
  {
    n: "01",
    title: "Share your sauna",
    body: "Send us the model, brand, and where you want it installed. Photos welcome.",
  },
  {
    n: "02",
    title: "Free assessment",
    body: "We review site conditions — foundation, power, ventilation, doorways — and quote transparently.",
  },
  {
    n: "03",
    title: "Precision assembly",
    body: "Our crew arrives with the right tools and follows manufacturer specs to the millimeter.",
  },
  {
    n: "04",
    title: "First löyly, on us",
    body: "We walk you through operation and stay until everything is running perfectly and you're ready to enjoy your sauna.",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="border-t border-[#E5E0D8]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <p className="overline mb-5">The Process</p>
            <h2 className="font-serif-display font-light text-4xl md:text-5xl text-text-main leading-tight">
              From cardboard boxes
              <br />
              <span className="italic text-cedar">to first steam.</span>
            </h2>
            <p className="text-text-muted mt-6 text-base md:text-lg leading-relaxed max-w-md">
              A calm, deliberate process — designed for clients who value their home and their time.
            </p>
            <div className="mt-10 aspect-[4/5] overflow-hidden rounded-2xl border border-[#E5E0D8] group">
              <img
                src="https://images.unsplash.com/photo-1645651964715-d200ce0939cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxjYXJwZW50ZXIlMjB0b29scyUyMHdvb2R8ZW58MHx8fHwxNzgzMzEwNzIyfDA&ixlib=rb-4.1.0&q=85"
                alt="Carpenter tools on wood, representing precision assembly"
                className="w-full h-full object-cover img-zoom"
                data-testid="process-image"
              />
            </div>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <ol className="space-y-10">
              {STEPS.map((s, i) => (
                <li
                  key={s.n}
                  data-testid={`process-step-${i}`}
                  className="grid grid-cols-12 gap-6 pb-10 border-b border-[#E5E0D8] last:border-b-0"
                >
                  <div className="col-span-3 md:col-span-2">
                    <span className="font-serif-display italic text-4xl md:text-5xl text-cedar">{s.n}</span>
                  </div>
                  <div className="col-span-9 md:col-span-10">
                    <h3 className="font-serif-display text-2xl md:text-3xl text-text-main">{s.title}</h3>
                    <p className="text-text-muted mt-3 leading-relaxed max-w-lg">{s.body}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
